import * as Models from "../ts/rlAdmin.models";
import { BaseEntityController } from "./baseEntityController";
import { LocalCacheService } from "../services/local-cache-service";
import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";
import { SearchService } from "../services/search-service";


export interface ISearchCommand {
    onPushState: () => void;
}


export class BaseSearchController<T> extends BaseEntityController implements ISearchCommand {

    search: boolean;                                            // used to force <advanced-search/> to refresh
    initialized: boolean;		                                // initialized flag
    keywords: string;			                                // search keywords
    itemRows: T[];			                                    // search result item rows
    // TODO: Models.IPagingOptions
    page: number;				                                // current page
    pageCount: number;			                                // current page	count of search	results
    qTime: number;				                                // time	in ms of search	operation
    jumpTo: number;				                                // jump-to input value
    selectedStatus: string;		                                // current selected	status
    selectedTemplate: string;	                                // current selected	template
    templates: Models.IKeyValuePair<string, number>[];			// template	data for select	box
    templateFacets: Models.IKeyValuePair<string, string>[];
    statuses: Models.IKeyValuePair<string, number>[];			// status data for select box
    statusFacets: Models.IKeyValuePair<string, string>[];		// status data for select box
    workflowActions: Models.IKeyValuePair<string, number>[];	// available workflow actions
    selectedAction: string;		                                // selected	workflow action
    sortField: string;			                                // sort by field (matches a solr field)
    sortDir: number;				                            // sort by direction.  0 - asc, 1 - desc
    allChecked: boolean;
    selectedItems: { [key: string]: boolean };
    numFound: number;
    showClear: boolean;                                         // whether or not to show the clear button
    relatedToMe: boolean;                                       // flag for only showing entities that pertain to the logged in user
    relatedSearch: boolean;                                     // if loading child char types

    templateGroupIDs: number[];
    searching: boolean;
    rowCount: number;
    searchGroups: Models.ISearchGroup[];

    get templateID(): number {
        if (this.selectedTemplate) {
            return parseInt(this.selectedTemplate.split('|')[1]);
        }

        return 0;
    }

    get statusID(): number {
        if (this.selectedStatus) {
            return parseInt(this.selectedStatus.split('|')[1]);
        }

        return 0;
    }

    charTypeId: number;
    templateGroupIds: number[];

    selectedCustomColumns: Models.ICustomUserColumns;

    //showBulkEditModal: boolean;
    //isModuleLevelBulkEdit: boolean;
    //selectedEntityIDs: string[];
    //selectedRecIDs: number[];

    onPushState: () => void;
    onSimpleSearch: () => void;

    constructor(
        private $baseScope: ng.IScope,
        $q: ng.IQService,
        private $baseLocation: ng.ILocationService,
        private $baseFilter: ng.IFilterService,
        localStorage: LocalCacheService,
        private baseNotifyService: NotifyService,
        entityService: EntityService,
        searchService: SearchService) {

        super($baseScope, $q, entityService, localStorage, baseNotifyService);

        this.initialized = false;		// initialized flag
        this.keywords = "";			    // search keywords
        this.itemRows = [];			    // search result item rows
        this.page = 1;				    // current page
        this.pageCount = 1;			    // current page	count of search	results
        this.numFound = 0;
        this.qTime = 0;				    // time	in ms of search	operation
        this.jumpTo = 1;				// jump-to input value
        this.selectedStatus = null;		// current selected	status
        this.selectedTemplate = null;	    // current selected	template
        this.templates = [];			// template	data for select	box
        this.templateFacets = [];
        this.statuses = [];			    // status data for select box
        this.workflowActions = [];	    // available workflow actions
        this.selectedAction = null;		// selected	workflow action
        this.sortField = "";			// sort by field (matches a solr field)
        this.sortDir = 0;				// sort by direction.  0 - asc, 1 - desc
        this.allChecked = false;
        this.selectedItems = {};
        this.showClear = false;
        this.relatedToMe = this.relatedToMe || false;
        this.relatedSearch = false;
        this.searching = false;
        this.rowCount = 25;
        this.searchGroups = [];
        //this.showBulkEditModal = false;
        //this.isModuleLevelBulkEdit = false;            
        //this.selectedRecIDs = [];

        //$baseScope.$watch(() => this.templates,
        //    (newValue: Models.IKeyValuePair<string, number>[], oldValue: Models.IKeyValuePair<string, number>[]) => {
        //        if (newValue != oldValue) {
        //            this.templateFacets = $baseFilter<Filters.IFacetFilter>("facetFilter")(newValue);
        //        }
        //    }, true);

        //$baseScope.$watch(() => this.statuses,
        //    (newValue: Models.IKeyValuePair<string, number>[], oldValue: Models.IKeyValuePair<string, number>[]) => {
        //        if (newValue != oldValue) {
        //            this.statusFacets = $baseFilter<Filters.IFacetFilter>("facetFilter")(newValue);
        //        }
        //    }, true);

        //// if template changed, reset status
        //$baseScope.$watch(() => this.selectedTemplate, (newValue: string, oldValue: string) => {
        //    if (newValue != oldValue) {
        //        this.selectedStatus = "";
        //    }
        //});

        //// if template or status changed, reset page to 1
        //$baseScope.$watch(() => [this.selectedStatus, this.selectedTemplate],
        //    (newValue: any[], oldValue: any[]) => {
        //        this.page = 1;
        //    }, true);

        // if template, status, page, sortDir, or sortField changes, update search
        //$baseScope.$watch(() => [this.page, this.selectedStatus, this.selectedTemplate, this.sortDir, this.sortField, this.relatedToMe],
        //    (newValue: any[], oldValue: any[]) => {
        //        if (newValue != oldValue) {
        //            this.onPushState();
        //        }
        //    }, true);

        //$baseScope.$watch(() => this.searching, (newValue, oldValue) => {
        //    if (newValue && !oldValue) {
        //        this.onPushState();
        //    }
        //});

        $baseScope.$watch<string[]>(() => [this.keywords, this.selectedStatus, this.selectedTemplate],
            (newValue, oldValue) => {
                this.showClear = _.any(newValue, (val) => !_.isEmpty(val));
            }, true);
    }

    Initialize() {
        var search = this.$baseLocation.search().s || window.btoa('{}');
        var searchState = JSON.parse(window.atob(search));

        if (this.keywords != searchState.k || this.page != _.parseInt(searchState.p || 1) || this.selectedStatus != searchState.s
            || this.selectedTemplate != searchState.t || this.relatedToMe != _.parseInt(searchState.rtm || 0) > 0) {
            this.keywords = searchState.k || "";
            this.page = _.parseInt(searchState.p || 1);
            this.selectedStatus = searchState.s || null;
            this.selectedTemplate = searchState.t || null;
            this.relatedToMe = _.parseInt(searchState.rtm || 0) > 0;
        }

        if (!this.sortField && !this.sortDir) {
            this.sortField = searchState.sf || "";
            this.sortDir = _.parseInt(searchState.sd || 0);
        }

        if (this.relatedSearch) {
            this.search = true;
        }

        this.initialized = true;
    }

    // fired when search button	is clicked
    SearchSubmit() {
        //$event.preventDefault();
        this.page = 1;				    // reset page
        this.selectedItems = {};	    // reset selected contacts
        this.RunSearch();			// push	state
    }

    // push	search state to	the	url	hash


    ClearSearch($event: ng.IAngularEvent) {
        $event.preventDefault();

        this.keywords = "";
        this.selectedTemplate = null;
        this.selectedStatus = null;
        this.page = 1;
        this.sortField = "";
        this.sortDir = 0;
        this.selectedAction = "";
        this.selectedItems = {};
        this.relatedToMe = false;
        this.RunSearch();
    }

    PageChanged(page: number) {
        this.page = page;
        this.RunSearch();
    }

    PageSizeChanged(pageSize: number) {
        this.page = 1;
        this.rowCount = pageSize;
        this.RunSearch();
    }

    ColumnsSelected(columns: Models.ICustomUserColumns) {
        this.selectedCustomColumns = columns;
        this.RunSearch();
    }

    SortChanged(sortField: string, sortDir: number) {
        this.sortField = sortField;
        this.sortDir = sortDir;
        this.RunSearch();
    }

    TemplateChanged() {
        this.selectedStatus = null;
        this.RunSearch();
    }

    StatusChanged() {
        this.RunSearch();
    }

    RunSearch() {
        if (this.onPushState != null) {
            this.onPushState();
        } else if (this.onSimpleSearch != null) {
            this.onSimpleSearch();
        }
    }

}

export class GenericSearchController extends BaseSearchController<Models.IEntitySearchDoc> {
    static $inject = ["$scope", "$q", "$location", "$filter", "localCacheService", "notifyService", "entityService", "searchService"];

    constructor(
        $scope: ng.IScope,
        $q: ng.IQService,
        $location: ng.ILocationService,
        private $filter: ng.IFilterService,
        localStorage: LocalCacheService,
        notifyService: NotifyService,
        entityService: EntityService,
        searchService: SearchService) {

        super($scope, $q, $location, $filter, localStorage, notifyService, entityService, searchService);
    }

    Init(charTypeId: number) {
        this.charTypeId = charTypeId;
    }
}
